var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"helvetica",class:_vm.asd,attrs:{"id":"demoTag"}},[_vm._v("\n    DEMO\n  ")])}
var staticRenderFns = []

export { render, staticRenderFns }